<script>

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
//import tableMunicipality from "@/components/widgets/tableMunicipality";
import { todoMethods, todoComputed } from "@/state/helpers";
import { tableData } from "../dataAdvancedtable";
import Fields from "@/helpers/fields";
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

export default {
  page: {
    title: "Municipios",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    //tableMunicipality,
  },
  data() {
    return {
      filters: {
        total: { value: "", keys: ["total"] },
      },
      result: null,

      // ************************************** Link
      tableData: tableData,
      title: "Municipios",
      items: [
        {
          text: "Escritorio",
          href: "/",
        },
        {
          text: "Municipios",
          active: true,
        },
      ],

      info: null,
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      statData: 1,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: "",
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      municipiosField: Fields.municipiosFields,
      tableMunicipalitys: [],
    };
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {
    this.getTable();

    this.fetchTodos();

    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;

    document.getElementById("b_table_municipalities").firstElementChild.classList.add("table-light");
  },

  methods: {
    ...todoMethods,

    getTable() {
      this.isLoading = true;
      axios.get("/municipios?type=todo").then((response) => {
        this.response = response.data.data;
        this.tableMunicipalitys = response.data.data;
        this.isLoading = false;
        console.log(response);
      }).catch((error) => {
        this.isLoading = false;
        console.log(error);
      });
    },

    handleEdit(id_municipio){
      console.log(id_municipio);
      this.$router.push({
        name:'ActualizaMunicipio',
        params:{
          id_municipio:id_municipio
        }
      })
    },

    handleDelete(id_municipio) {
      this.$swal({
        title: "¿Estas seguro de borrar?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .put(
              "/municipios",
              { id_municipio: id_municipio, active: "0" }
            )
            .then((res) => {
              const { response = "" } = res.data;
              if (response === true) {
                this.$swal(
                  "Eliminado",
                  "Municipio eliminado correctamente",
                  "success"
                );
                this.getTable();
              } else {
                this.$swal("Alerta", "No se pudo eliminar", "warning");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$swal("Error", "Ocurrio un error", "error");
            });
        }
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <h4 class="card-title mb-4">Registro de municipios</h4>
              </div>
              <div class="col-sm-12 col-md-6 text-md-end">
                <router-link to="/NuevoMunicipio">
                  <v-btn
                    depressed
                    color="primary"
                    type="button"
                    id="button-addon2"
                    href="/"
                  >
                    Nuevo registro
                  </v-btn>
                </router-link>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Ver
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    <v-divider class="mx-1" inset vertical></v-divider>

                    registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div class="d-flex justify-content-center align-items-center h-50" v-if="isLoading == true">
              <b-spinner variant="primary"></b-spinner>
            </div>
            <!-- tableMunicipalitys table -->
            <b-table
              v-else
              id="b_table_municipalities"
              :fields="municipiosField"
              :items="tableMunicipalitys"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template #cell(id_municipio)="data">
                <a href="javascript: void(0);" class="text-body fw-bold">
                  {{ data.item.id_municipio }}
                </a>
              </template>
              <template #cell(estatus)="data">
                <span
                  class="badge badge-pill bg-success font-size-11"
                  :class="{
                    'bg-warning': `${data.item.estatus}` === '0',
                    'bg-success': `${data.item.estatus}` === '1',
                  }"
                  >{{ data.item.estatus === 1 ? "Activo" : "Desactivo" }}</span
                >
              </template>
              <template #cell(edit)="data">
                <v-btn
                  icon
                  small
                  @click="handleEdit(data.item.id_municipio)"
                >
                  <i style="color: #09a5c7" class="bx bxs-pencil"></i>
                </v-btn>
                <v-btn
                  icon
                  small
                  @click="handleDelete(data.item.id_municipio)"
                >
                  <i style="color: #e73484" class="bx bx-trash"></i>
                </v-btn>
              </template>
            </b-table>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <v-divider class="mx-2" inset vertical></v-divider>
              Mostrando {{ perPage > tableMunicipalitys.length ? tableMunicipalitys.length : perPage }} de {{ tableMunicipalitys.length }} registros
            </div>
            <div class="col-sm-12 col-md-6 text-md-end pr-10">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="tableMunicipalitys.length"
                :per-page="perPage"
                first-text="Primera"
                prev-text="Anterior"
                next-text="Siguiente"
                last-text="Última"
              ></b-pagination>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </Layout>
</template>